var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCb008(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 16,
    viewBox: "0 0 79 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2562_21141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V16H78.2123V0H0ZM75.9777 13.7654H2.23464V2.23464H75.9777V13.7654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7267 3.84357H71.3301V12.1788H74.7267V3.84357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.631 3.84357H66.2344V12.1788H69.631V3.84357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5588 3.84357H61.1621V12.1788H64.5588V3.84357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 3.84357H56.0664V12.1788H59.4631V3.84357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3693 3.84357H50.9727V12.1788H54.3693V3.84357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2736 3.84357H45.877V12.1788H49.2736V3.84357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1564 3.84357H40.7598V12.1788H44.1564V3.84357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0607 3.84357H35.6641V12.1788H39.0607V3.84357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5646 3.84357H30.168V12.1788H33.5646V3.84357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4689 3.84357H25.0723V12.1788H28.4689V3.84357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3752 3.84357H19.9785V12.1788H23.3752V3.84357Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2562_21141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.2123,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCb008);
export default __webpack_public_path__ + "static/media/cb_008.88abbcd4271b8917908b331765b1e088.svg";
export { ForwardRef as ReactComponent };